import { SubscriptionHookOptions, useSubscription } from '@apollo/client';

import {
  CreditCardEnabledDocument,
  type CreditCardEnabledSubscription,
  type CreditCardEnabledSubscriptionVariables,
} from './creditCardEnabledSubscription.gql';

export const useCreditCardEnabledSubscription = (
  options: SubscriptionHookOptions<
    CreditCardEnabledSubscription,
    CreditCardEnabledSubscriptionVariables
  > = {},
) => {
  return useSubscription(CreditCardEnabledDocument, options);
};
